import { FetchRequiredOnboardingRequestTypes } from '../actions/RequiredOnboardingActions';
const initialState = {};
const RequiredOnboarding = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchRequiredOnboardingRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        if (!(data !== null && data !== void 0 && data.requiredOnboarding)) {
          return state;
        }
        return Object.assign({}, state, data.requiredOnboarding);
      }
    default:
      return state;
  }
};
export default RequiredOnboarding;